import type {z} from "zod";

import {EditRepresentativeNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editRepresentativeNoteTitleSchema = requiredStringSchema(
  EditRepresentativeNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editRepresentativeNoteContentSchema = requiredStringSchema(
  EditRepresentativeNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const editRepresentativeNoteFormSchema = EditRepresentativeNoteBody.extend({
  title: editRepresentativeNoteTitleSchema,
  content: editRepresentativeNoteContentSchema,
});
export type EditRepresentativeNoteFormPayload = z.output<typeof editRepresentativeNoteFormSchema>;

export const draftEditRepresentativeNoteFormSchema = editRepresentativeNoteFormSchema.partial();
export type DraftEditRepresentativeNoteFormPayload = z.output<
  typeof draftEditRepresentativeNoteFormSchema
>;
